<template>
  <div class="cart d-flex-column justify-start align-start">
    <div class="d-flex-row space-between flex-1">
      <h4 class="font-family-1 title-h5 t-white">
        {{ $t("cart.summary") }}
      </h4>
      <Tooltip
        :text="$t('delivery_time')"
        v-if="
          checkoutStore.fullPack?.slug !== 'buy-wow-gold' &&
          checkoutStore?.fullGame?.slug !== 'fc-boost' &&
          !['ow-galactic-guns-boost'].includes(currentGamePackSlug)
        "
      >
        <div class="d-flex-row justify-end flex-5 cursor-pointer">
          <h5
            class="white-space-no t-grey font-family-2 medium-l cursor-pointer"
          >
            ~ {{ secondsToDays(time) }}
          </h5>
          <clock-icon />
          <PoiIcon />
        </div>
      </Tooltip>
    </div>
    <SoloDuoPicker
      v-if="checkoutStore.fullGame?.slug !== 'world-of-warcraft-boost'"
    />

    <GalacticGunCart v-if="currentGamePackSlug === 'ow-galactic-guns-boost'" />

    <FcCoinBoostCart v-if="currentGamePackSlug === 'fc-coins-boost'" />
    <LazyCalculatorsFc25FcCoachingBoostCart
      v-if="currentGamePackSlug === 'fc-coaching-boost'"
    />
    <LazyCalculatorsFc25FcSquadBoostCart
      v-else-if="currentGamePackSlug === 'fc-squad-battles-boost'"
    />
    <LazyCalculatorsFc25Fc25ObjectiveBoostCart
      v-else-if="currentGamePackSlug === 'fc-objectives-boost'"
    />
    <LazyCalculatorsFc25Fc25CampaignFinalsBoostCart
      v-else-if="currentGamePackSlug === 'fc-fut-champions-final-boost'"
    />
    <LazyCalculatorsFc25Fc25CampaignPlayOffCart
      v-else-if="currentGamePackSlug === 'fc-fut-champions-playoffs-boost'"
    />
    <LazyCalculatorsFc25Fc25DivisionRivalsCart
      v-else-if="currentGamePackSlug === 'fc-division-rivals-boost'"
    />
    <LazyCalculatorsFc25Fc25DivisionRivalsWins
      v-else-if="currentGamePackSlug === 'fc-division-rivals-wins-boost'"
    />
    <FcBundesligsBoostCart
      v-else-if="currentGamePackSlug === 'fc-tots-cup-boost'"
    />
    <RaidTimeLeft v-if="checkoutStore?.raid?.id" />
    <ArenaModePicker
      v-if="
        ['wow-2v2-arena-boost', 'wow-3v3-arena-boost'].includes(
          categoryPackSlug
        )
      "
    />
    <ServerPicker
      v-if="
        [
          'wow-2v2-arena-boost',
          'wow-3v3-arena-boost',
          'wow-mythic-dungeon-boost',
          'wow-leveling-boost',
          'wow-raid-boost',
          'wow-solo-shuffle-boost',
          'wow-battlegrounds-boost',
          'wow-honor-boost',
          'wow-conquest-boost',
          'wow-battleground-blitz-boost',
        ].includes(categoryPackSlug) ||
        checkoutStore.fullPack?.slug === 'buy-wow-gold'
      "
    />
    <hr
      class="horizontal"
      style="margin: 8px 0"
      v-if="
        [
          'wow-2v2-arena-boost',
          'wow-3v3-arena-boost',
          'wow-mythic-dungeon-boost',
          'wow-leveling-boost',
          'wow-solo-shuffle-boost',
          'wow-raid-boost',
          'wow-battlegrounds-boost',
          'wow-honor-boost',
          'wow-conquest-boost',
          'wow-battleground-blitz-boost',
        ].includes(categoryPackSlug) ||
        checkoutStore.getSelectedPack?.slug === 'buy-wow-gold'
      "
    />

    <CartOptionPicker
      v-if="
        [
          'wow-2v2-arena-boost',
          'wow-3v3-arena-boost',
          'wow-mythic-dungeon-boost',
          'wow-leveling-boost',
          'wow-raid-boost',
        ].includes(categoryPackSlug)
      "
    />
    <hr
      class="horizontal"
      style="margin: 8px 0"
      v-if="
        [
          'wow-2v2-arena-boost',
          'wow-3v3-arena-boost',
          'wow-mythic-dungeon-boost',
          'wow-leveling-boost',
          'wow-raid-boost',
        ].includes(categoryPackSlug)
      "
    />

    <ClassAndSpecialization v-if="showClassAndSpecializationMmo" />
    <hr
      class="horizontal"
      style="margin: 8px 0"
      v-if="checkoutStore.fullPack?.slug === 'buy-wow-gold'"
    />
    <CartRealmPicker v-if="checkoutStore.fullPack?.slug === 'buy-wow-gold'" />
    <hr
      class="horizontal"
      style="margin: 8px 0"
      v-if="checkoutStore.fullPack?.slug === 'buy-wow-gold'"
    />

    <NumberOfBoosterPicker />

    <div
      class="d-flex-column justify-start align-start gap-9"
      v-if="
        checkoutStore?.fullGame?.slug !== 'fc-boost' &&
        currentGamePackSlug !== 'ow-galactic-guns-boost'
      "
    >
      <OrderDetail
        :base-price="basePrice"
        v-if="
          currentGamePackSlug !== 'apex-legends-badges-boosting' &&
          currentGamePackSlug !== 'the-finals-gadgets-weapons-boost'
        "
      />
      <SelectedDifficulty />
      <PickedItems />
      <PickedCamo />
      <SelectedOptions />
      <PickedExtraOptions />
      <PickedRoles />
      <PickedBadges />
      <PickedGadgets />
      <PickedDungeon />
      <PickedPlatform
        v-if="currentGameSlug !== 'world-of-warcraft-boost' && currentGameSlug"
      />
    </div>
    <SpecificBooster
      v-if="
        checkoutStore.fullGame?.slug !== 'world-of-warcraft-boost' &&
        checkoutStore.fullGame?.slug !== 'path-of-exile-2-boost' &&
        checkoutStore.fullGame?.slug !== 'fc-boost'
      "
    />
    <ApplyPromo
      :total-price="price"
      v-if="checkoutStore.fullPack?.coupon_enable !== 0"
    />
    <hr
      class="horizontal"
      style="margin: 8px 0"
      v-if="checkoutStore.fullPack?.coupon_enable !== 0"
    />
    <CartTime
      v-if="
        checkoutStore.fullGame?.slug === 'fc-boost' ||
        ['ow-galactic-guns-boost'].includes(currentGamePackSlug)
      "
      :time="time"
    />

    <CartAppliedCoupon
      :coupon="checkoutStore.getSelectedCoupon"
      :non-discounted-price-usd="nonDiscountedUsdPrice"
      :non-discounted-usd-price-base="nonDiscountedUsdPriceBase"
      v-if="
        nonDiscountedUsdPrice > 0 || checkoutStore.getSelectedCoupon?.discount
      "
    />

    <ProgressiveDiscount
      :non-discounted-price="nonDiscountedPrice"
      v-model="progressiveDiscount"
      v-if="getGamePack?.progress_discount?.length > 0"
    />

    <div class="d-flex-column gap-12" id="checkout_btn">
      <div class="d-flex-row space-between" v-if="progressiveDiscount > 0">
        <p class="t-light font-family-2 regular-l">
          {{ $t("checkout.provision_discount") }}
        </p>
        <p class="t-blue f-w-800 font-family-2 regular-l">
          -{{ progressiveDiscount }}%
        </p>
      </div>
      <!-- COUPON -->
      <div
        class="d-flex-row space-between"
        v-if="checkoutStore?.getSelectedCoupon?.discount"
      >
        <p class="t-light font-family-2 regular-l">
          {{ $t("checkout.promo") }}
        </p>
        <p class="t-blue f-w-800 font-family-2 regular-l">
          {{ renderCoupon(checkoutStore?.getSelectedCoupon) }}
        </p>
      </div>
      <!-- TOTAL AMOUNT -->
      <div class="d-flex-row space-between">
        <p class="t-light font-family-2 regular-l">
          {{ $t("checkout.total_amount") }}
        </p>
        <p class="t-white font-family-2 bold-l">
          <span class="t-grey medium-l font-family-2 strike-through">
            {{ getUserCurrencyCode
            }}{{ parseFloat(computedNonDiscountedPrice).toFixed(2) }}</span
          >
          {{ getUserCurrencyCode }}{{ parseFloat(renderPrice).toFixed(2) }}
        </p>
      </div>
      <!-- CASSHBACK -->
      <div class="d-flex-row space-between">
        <p class="t-light font-family-2 regular-l">
          {{ $t("checkout.cashback") }}
        </p>
        <p
          class="t-white font-family-2 bold-l d-flex-row justify-end gap-0 flex-5"
        >
          <BmCoinIcon style="margin-right: 5px" />
          {{ getUserCurrencyCode }}
          {{ parseFloat(cashback).toFixed(2) }}
        </p>
      </div>
      <!-- STRIPE BUTTON -->
      <div
        id="stripe-payment-request-button"
        class="stripe-service-button"
        :class="[displayStripeButton && 'visible']"
      ></div>
      <div id="express-checkout-element" class="stripe-express-button"></div>

      <button
        class="secondary filled xl full-width height-48 b-radius-9 font-family-1 body-l f-w-600"
        :disabled="isDisabled || isGoldLessThanStock || isPriceLessThanTwo"
        @click.stop="createOrder(false)"
      >
        {{ $t("checkout.checkout") }} ({{ getUserCurrencyCode }}
        {{ parseFloat(renderPrice).toFixed(2) }})
      </button>

      <div
        class="warning_message d-flex-row justify-start"
        v-if="isPriceLessThanTwo"
      >
        <img
          src="/images/icons/warning-icon-2.webp"
          alt="warning_icon"
          height="30"
          width="30"
        />
        <div class="d-flex-column justify-start align-start gap-3">
          <p class="t-light font-family-2 medium-m">
            {{ $t("less_than_error") }} {{ getUserCurrencyAbr }}
            {{ getUserCurrencyCode
            }}{{ parseFloat(calculateCurrency(5)).toFixed(2) }}.
          </p>
        </div>
      </div>

      <div class="d-flex-row membership" v-if="getUser.username">
        <div
          class="content_area d-flex-column justify-start align-start gap-15"
        >
          <div class="d-flex-row space-between become_a_member b-radius-6">
            <div class="d-flex-row justify-start flex-9">
              <Checkbox
                variant="secondary"
                v-model="useCashback"
                selectable-value="true"
              />
              <label class="t-white bold-xl font-family-2"
                >{{ $t("checkout.use_cashback_1") }}
                {{ $t("checkout.use_cashback_2") }}
                <span class="t-light-orange">
                  <!-- {{ getUserCurrencyCode }} -->
                  $
                  {{
                    getUser.cashback
                      ? parseFloat(getUser.cashback).toFixed(2)
                      : 0
                  }}
                </span>
              </label>
            </div>
            <CashbackIcon3 />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <Modal :is-open="isLoginOpen" :toggle="toggleLoginOpen"> </Modal> -->

  <transition name="slide-fade-bottom">
    <div
      class="sticky_checkout_button d-flex-column with_option above-md-hide"
      v-show="!hasReachedCheckout && currentGamePackSlug !== 'buy-wow-gold'"
    >
      <MobileSummary v-if="currentGameSlug === 'ow-boost'" />
      <SoloDuoPicker
        v-if="checkoutStore.fullGame?.slug !== 'world-of-warcraft-boost'"
        style="min-height: 48px"
      />
      <hr
        class="horizontal"
        style="margin: 2px 0"
        v-if="checkoutStore.fullGame?.slug !== 'world-of-warcraft-boost'"
      />
      <button
        class="secondary filled xl full-width height-48 b-radius-9 font-family-1 body-l f-w-600"
        :disabled="isDisabled || isGoldLessThanStock || isPriceLessThanTwo"
        @click.stop="createOrder(false)"
      >
        {{ $t("checkout.checkout") }} ({{ getUserCurrencyCode }}
        {{ parseFloat(renderPrice).toFixed(2) }})
      </button>
    </div>
  </transition>
  <Modal :is-open="isLoginOpen" :toggle="toggleLoginOpen">
    <!-- <LoginForm :continue-checkout="continueCheckout" /> -->
    <LoginForm :continue-checkout="continueCheckout" />
  </Modal>
</template>

<script setup>
import ClockIcon from "~/components/icons/ClockIcon.vue";
import OrderDetail from "./OrderDetail.vue";
import SelectedOptions from "./SelectedOptions.vue";
import PickedExtraOptions from "./PickedExtraOptions.vue";
import PickedRoles from "./SelectedRoles.vue";
import SelectedDifficulty from "./SelectedDifficulty.vue";
import PickedBadges from "./PickedBadges.vue";
import PickedGadgets from "./PickedGadgets.vue";
import PickedDungeon from "./PickedDungeon.vue";
import SpecificBooster from "./SpecificBooster.vue";
import ApplyPromo from "./ApplyPromo.vue";
import CartAppliedCoupon from "./CartAppliedCoupon.vue";
import ProgressiveDiscount from "./ProgressiveDiscount.vue";
import BmCoinIcon from "~/components/icons/BmCoinIcon.vue";
import Modal from "~/components/common/Modal.vue";
import LoginForm from "~/components/forms/LoginForm.vue";
// import WoWRaidSchedule from "./WoWRaidSchedule.vue";
import Checkbox from "~/components/custom/Checkbox.vue";
import CashbackIcon3 from "~/components/icons/CashbackIcon3.vue";
import PickedCamo from "./PickedCamo.vue";
import PickedItems from "./PickedItems.vue";
import ClassAndSpecialization from "../wow/pickers/ClassAndSpecialization.vue";
import RaidTimeLeft from "./RaidTimeLeft.vue";
import ServerPicker from "../wow/pickers/ServerPickerMini.vue";
import ArenaModePicker from "../wow/pickers/ArenaModePicker.vue";
import PickedPlatform from "./PickedPlatform.vue";
import Tooltip from "~/components/custom/Tooltip.vue";
import CartRealmPicker from "../wow/pickers/CartRealmPicker.vue";
import PoiIcon from "~/components/icons/PoiIcon.vue";
import SoloDuoPicker from "./SoloDuoPicker.vue";
import NumberOfBoosterPicker from "./NumberOfBoosterPicker.vue";
import GalacticGunCart from "../overwatch/carts/GalacticGunCart.vue";
import {
  calculateChoose,
  calculateCurrency,
} from "../../../calculate/calculatePrice";
import { loadStripe } from "@stripe/stripe-js";
import { ref, computed, onBeforeMount, onBeforeUnmount, watch } from "vue";
import { useGtm } from "@gtm-support/vue-gtm";
import device from "~/plugins/device";
import CartOptionPicker from "../wow/pickers/CartOptionPicker.vue";
import CartTime from "./CartTime.vue";
import FcCoinBoostCart from "../fc-25/FcCoinBoostCart.vue";
import MobileSummary from "./MobileSummary.vue";
import FcBundesligsBoostCart from "../fc-25/FcBundesligsBoostCart.vue";
// import { LazyCalculatorsFc25FcCoachingBoostCart } from "#build/components";
const { isMobile } = device().provide;
const { currentGamePackSlug, currentGameSlug, categoryPackSlug } =
  useGameComposable();
const {
  getUserCurrencyCode,
  getUser,
  // ,
  getUserCurrencyAbr,
  getUserCurrency,
  getUtm,
} = useUserStore();
const userStore = useUserStore();
const $gtm = useGtm();
const { setSnack, setBasePrice } = useGenericStore();
const { public: publicConfig } = useRuntimeConfig();
const { getGamePack } = useGameStore();
const { nuxtEnv } = publicConfig;

const checkoutStore = useCheckoutStore();
const router = useRouter();
const localePath = useLocalePath();
const route = router.currentRoute;

const price = ref(0);
const basePrice = ref(0);
const time = ref(0);
const cashback = ref(0);
const computedNonDiscountedPricee = ref(0);
const nonDiscountedUsdPrice = ref(0);
const isDisabled = ref(false);
const viewItem = ref(false);
const beginCheckout = ref(false);
const progressiveDiscount = ref(0);
const nonDiscountedUsdPriceBase = ref(0);
const hasReachedCheckout = ref(true);
const timeout = ref(null);
const displayStripeButton = ref(false);
const paymentRequest = ref(null);
const selectedPaymentMethod = ref(7);
const nonDiscountedPrice = ref(0);
const stripe = ref(null);
const elements = ref(null);
const element = ref(null);

const useCashback = ref("");
const use_cashback = ref(false);
const hasMounted = ref(false);
const isLoginOpen = ref(false);
const computedNonDiscountedPrice = computed(() => {
  if (nonDiscountedPrice.value === price.value) {
    return price.value + (price.value * 10) / 100;
  }
  return nonDiscountedPrice.value;
});

const isGoldLessThanStock = computed(() => {
  if (
    route.value.params.gamePackSlug === "wow-raid-boost" &&
    !checkoutStore?.getSelectedRaid?.id
  ) {
    return true;
  }
  if (
    checkoutStore?.getDetails?.inStock < checkoutStore?.getDetails?.numberOfGold
  ) {
    return true;
  }
  return false;
});
const isPriceLessThanTwo = computed(() => {
  if (price.value <= 5) {
    return true;
  }
  return false;
});

const toggleLoginOpen = () => {
  isLoginOpen.value = !isLoginOpen.value;
};

const stripeLoaded = ref(null);
const expressCheckoutMain = ref(null);
const stripeElementsRef = ref(null);

const updatePrice = () => {
  displayStripeButton.value = false;
  if (timeout.value) {
    clearTimeout(timeout.value);
  }
  timeout.value = setTimeout(() => {
    checkPaymentButton();
  }, 500);
};

const getGuestIntent = async () => {
  try {
    const data = await useApiPost("/api/create-guest-intent", {
      method: "POST",
    });

    return data;
  } catch (error) {
    console.log(error);
  }
};

const payOrder = async (invoice_code) => {
  try {
    const params = {
      invoice_code: invoice_code,
      type: "payment",
      payment_method: selectedPaymentMethod.value,
      use_cashback: use_cashback.value,
    };

    const { data: response } = await useApiPost("/api/pay-order", {
      method: "POST",
      body: {
        locale: getLocale(),
        ...params,
      },
    });

    if (response.properties) {
      const utmDataSet = getUtm;
      window?.analytics?.page("User paying order", {
        ...response.properties,
        ...utmDataSet,
      });
    }
    return response;
  } catch (error) {
    console.log(error);
  }
};

const renderPrice = computed(() => {
  if (use_cashback.value) {
    if (getUser.cashback > 0) {
      const convertedCashbackAmount = calculateCurrency(getUser.cashback);

      const amount = price.value - convertedCashbackAmount;

      if (amount <= 0) return 0;
      return amount;
    }
  }
  return price.value;
});
const onPaymentmethod = async (e) => {
  try {
    const order = await createOrder(false, false);
    const invoice_code = order.params.orderId;
    const payment = await payOrder(invoice_code);
    const pi = payment.payment_link;

    const { paymentIntent, error: confirmError } =
      await stripe.value.confirmCardPayment(
        pi,
        { payment_method: e.paymentMethod.id },
        { handleActions: false }
      );
    if (confirmError) {
      e.complete("fail");
      checkPaymentButton();
    } else {
      if (paymentIntent.status === "requires_action") {
        const { error } = await stripe.value.confirmCardPayment(pi);
        // if (error) {
        //   this.$emit("error", error);
        // } else {
        //   console.log("success 2 ");
        //   this.$emit("success");
        // }
      } else {
        setTimeout(() => {
          const path = `/dashboard/orders/${invoice_code}`;
          router.push(localePath({ path, query: { type: "payment" } }));
        }, 1000);
      }
    }
  } catch (error) {
    console.log(error);
  }
};
const checkPaymentButton = async () => {
  try {
    if (price.value && price.value > 2 && userStore.getUserLoggedIn) {
      stripe.value = await loadStripe(publicConfig.stripePublicKey);
      const ELEMENT_TYPE = "paymentRequestButton";

      let amount = price.value.toFixed(2);

      paymentRequest.value = stripe.value.paymentRequest({
        country: "US",
        currency: getUserCurrencyAbr.toLowerCase(),
        total: {
          label: "Order",
          amount: Math.round(amount * 100),
        },
        requestPayerName: true,
        requestPayerEmail: true,
      });

      elements.value = stripe.value.elements();
      element.value = elements.value.create(ELEMENT_TYPE, {
        paymentRequest: paymentRequest.value,
      });

      const result = await paymentRequest.value.canMakePayment();

      handleExpressCheckout();
      if (result?.applePay || result?.googlePay) {
        displayStripeButton.value = true;

        if (result?.applePay) {
          selectedPaymentMethod.value = 7;
        } else if (result?.googlePay) {
          selectedPaymentMethod.value = 8;
        }

        if (paymentRequest.value && element.value) {
          element.value.mount("#stripe-payment-request-button");
          paymentRequest.value.on("paymentmethod", onPaymentmethod);
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
};

const getBillingDetails = async () => {
  try {
    const response = await stripeLoaded.value.paymentIntents.create({
      amount: Math.round(amount * 100), // amount in cents
      currency: currency,
      payment_method_types: ["card"],
    });
    // const { paymentIntent, error } =
    //   await stripeLoaded.value.retrievePaymentIntent(e.clientSecret);
    // const email = paymentIntent.charges?.data[0]?.billing_details?.email;
    // console.log(paymentIntent.charges?.data[0]?.billing_details);
  } catch (error) {
    console.log(error);
  }
};
const handleExpressCheckout = async () => {
  try {
    hasMounted.value = true;

    const appearance = {
      theme: "minimal",
      variables: {
        fontFamily: ' "Clash Display", sans-serif',
        borderRadius: "9px",
      },
    };
    const options = {
      buttonHeight: 48,
      buttonType: {
        applePay: "plain",
        googlePay: "plain",
      },
      buttonTheme: {
        applePay: "white-outline",
        googlePay: "white",
      },
      layout: {
        maxRows: 0,
        maxColumns: 3,
        overflow: "never",
      },
    };
    stripeLoaded.value = await loadStripe(publicConfig.stripePublicKey);
    let amount =
      price.value > 0 ? price.value.toFixed(2) : parseFloat(5).toFixed(2);

    stripeElementsRef.value = stripeLoaded.value.elements({
      locale: getLocale(),
      mode: "payment",
      amount: Math.round(amount * 100),

      appearance,
      currency: getUserCurrencyAbr.toLowerCase(),
    });

    const stripeElements = stripeElementsRef.value;

    expressCheckoutMain.value = stripeElements.create(
      "expressCheckout",
      options
    );
    const expressCheckout = expressCheckoutMain.value;
    expressCheckout.mount("#express-checkout-element");
    expressCheckout.on("click", (e) => {
      if (e.expressPaymentType === "google_pay") {
        selectedPaymentMethod.value = 8;
      } else if (e.expressPaymentType === "apple_pay") {
        selectedPaymentMethod.value = 7;
      } else if (e.expressPaymentType === "link") {
        selectedPaymentMethod.value = 1;
      }
      e.resolve();
    });
    expressCheckout.on("cancel", (e) => {
      selectedPaymentMethod.value = null;
    });
    expressCheckout.on("confirm", async (e) => {
      expressConfirmPayment(e, stripeElements);
    });
  } catch (error) {
    console.log(error);
  }
};

const getUserInfo = async (clientSecret) => {
  try {
    let paymentIntent;
    let attempts = 0;
    let email = "";
    // Poll to check for charges data (limit retries)
    while (true) {
      ({ paymentIntent } = await stripeLoaded.value.retrievePaymentIntent(
        clientSecret
      ));
      if (paymentIntent.charges?.data.length) break;
      attempts += 1;
      await new Promise((resolve) => setTimeout(resolve, 1000)); // Delay before retry
    }

    email = paymentIntent?.charges?.data[0]?.billing_details?.email;
    return email;
  } catch (error) {
    console.error("Error confirming payment:", error);
  }
};

const expressConfirmPayment = async (e, stripeElements) => {
  try {
    const order = await createOrder(false, false);
    const invoice_code = order.params.orderId;
    const payment = await payOrder(invoice_code);
    const pi = payment.payment_link;
    const basePath = `${publicConfig.appUrl}/dashboard/orders/${invoice_code}?type=payment`;
    const { paymentIntent, error } = await stripeLoaded.value.confirmPayment({
      elements: stripeElements,
      clientSecret: pi,
      confirmParams: {
        return_url: basePath,
      },
      // redirect: 'if_required',
    });
    if (error) {
    } else {
    }
  } catch (error) {
    console.log(error);
  }
};

const sendDataLayerBeginCheckout = () => {
  if (nuxtEnv === "prod") {
    let otherParams = {};
    if (getUser.id) {
      otherParams = {
        user_data: {
          first_name: getUser.username,
          email_address: getUser.email,
          user_id: getUser.id,
          customer_lifetime_spent: getUser.total_spent,
        },
      };
    }
    if (
      checkoutStore &&
      getUserCurrency &&
      price.value &&
      price.value !== 0 &&
      window.dataLayer?.push
    ) {
      window.dataLayer?.push({
        event: "begin_checkout",
        ecommerce: {
          currency: getUserCurrencyCode,
          value: price.value.toFixed(2),
          coupon: checkoutStore.coupon || "",
          items: [
            {
              item_id: "game_pack_" + checkoutStore.fullPack.id || "",
              item_name: checkoutStore.fullPack.title || "",
              affiliation: checkoutStore.fullPack.slug || "",
              coupon: checkoutStore.coupon || "",
              discount: 0,
              index: 0,
              item_brand: checkoutStore.fullGame.slug || "",
              price: price.value.toFixed(2),
              quantity: 1,
            },
          ],
        },
        ...otherParams,
      });
    }
  }
};
const sendDataLayerAddShippingInfo = () => {
  if (nuxtEnv === "prod" && window.dataLayer?.push) {
    if (checkoutStore && getUserCurrency && price.value && price.value !== 0) {
      let otherParams = {};
      if (getUser.id) {
        otherParams = {
          user_data: {
            first_name: getUser.username,
            email_address: getUser.email,
            user_id: getUser.id,
            customer_lifetime_spent: getUser.total_spent,
          },
        };
      }
      window.dataLayer?.push({
        event: "add_shipping_info",
        ecommerce: {
          currency: getUserCurrencyCode,
          value: price.value.toFixed(2),
          coupon: checkoutStore.coupon || "",
          shipping_tier: "Instant",
          items: [
            {
              item_id: "game_pack_" + checkoutStore.fullPack.id || "",
              item_name: checkoutStore.fullPack.title || "",
              affiliation: checkoutStore.fullPack.slug || "",
              coupon: checkoutStore.coupon || "",
              discount: 0,
              index: 0,
              item_brand: checkoutStore.fullGame.slug || "",
              price: price.value.toFixed(2),
              quantity: 1,
            },
          ],
        },
        ...otherParams,
      });
    }
  }
};
const createOrder = async (passThrough = false, redirect = true) => {
  try {
    if (isPriceLessThanTwo.value) {
      return;
    }
    if (!beginCheckout.value) {
      sendDataLayerBeginCheckout();
      beginCheckout.value = true;
    }
    console.log(
      "userStore.getUserLoggedIn",
      userStore.getUserLoggedIn,
      !passThrough
    );
    if (!userStore.getUserLoggedIn && !passThrough) {
      toggleLoginOpen();
      return;
    }
    sendDataLayerAddShippingInfo();

    isDisabled.value = true;

    let params = {
      game: checkoutStore.fullGame?.id,
      pack: checkoutStore.fullPack?.id,
      packOptions: checkoutStore.packOptions,
      packExtraOptions: Object.values(checkoutStore.packExtraOptions),
      heroes: checkoutStore.heroes,
      roles: [...checkoutStore.roles],
      platform: checkoutStore.platform,
      booster: checkoutStore.booster,
      coupon_id: checkoutStore.coupon?.id || null,
      coupon: checkoutStore.coupon?.code || null,
      currency: getUserCurrency,
      server: checkoutStore.server?.value
        ? parseInt(checkoutStore.server?.value)
        : null,
      is_mmo:
        checkoutStore.fullGame?.slug === "world-of-warcraft-boost"
          ? true
          : false,
      raid_schedule: checkoutStore?.raid?.id || null,
      raid_date: checkoutStore?.raid?.raidDate || null,
      proposal_code: checkoutStore?.details?.proposalCode || null,
    };
    if (params.is_mmo && checkoutStore.realms?.length > 0) {
      params.realms = [...checkoutStore.realms];
    }
    if (checkoutStore.queue?.value) {
      params.packExtraOptions.push(checkoutStore.queue?.value);
    }
    if (checkoutStore.role) {
      params.roles.push(parseInt(checkoutStore.role));
    }

    if (checkoutStore.dungeons?.length > 0) {
      params = {
        ...params,
        dungeons: [...checkoutStore.dungeons],
      };
    }
    // if (checkoutStore.getDifficulty) {
    //   params.packOptions.push(checkoutStore.getDifficulty);
    // }

    let details = mapDetails(
      checkoutStore.details,
      params.game,
      params.pack,
      checkoutStore
    );
    if (checkoutStore.fullGame?.slug === "world-of-warcraft-boost") {
      details = mapMmoDetails(
        checkoutStore.details,
        params.game,
        params.pack,
        checkoutStore
      );
    }
    if (
      currentGamePackSlug === "black-ops-6-camo-boost" ||
      currentGamePackSlug === "black-ops-6-zombie-camo-boost" ||
      currentGamePackSlug === "warzone-camo-boost" ||
      currentGamePackSlug === "black-ops-6-nuke-boost" ||
      currentGamePackSlug === "black-ops-6-reticles-boost" ||
      currentGamePackSlug === "black-ops-6-zombie-reticles-boost" ||
      currentGamePackSlug === "black-ops-6-prestige-boost"
    ) {
      params = {
        ...params,
        packExtraOptions: [...params.packOptions],
        packOptions: [],
      };
    }
    // console.log(details);

    params = {
      ...params,
      details: { ...details },
    };
    isDisabled.value = false;
    const { data: response } = await useApiPost("/api/create-order", {
      method: "POST",
      body: {
        locale: getLocale(),
        ...params,
      },
    });

    // console.log(data);
    if (response.message) {
      setSnack({
        title: response.message_title,
        description: response.message,
        timeout: 5000,
        showProgress: true,
        type: response.message_status.toLowerCase(),
        position: "top-right",
        isOpen: true,
      });
    }

    if (response.properties) {
      const utmDataSet = getUtm;
      window?.analytics?.track("User created order", {
        ...response.properties,
        ...utmDataSet,
      });
    }

    if (response.redirect === "order_checkout" && redirect) {
      const path = `/checkout/${response.params.orderId}`;
      router.push({
        path: localePath(path),
        query: {
          apply_cashback: use_cashback.value,
        },
      });
    }
    isDisabled.value = false;
    return response;
  } catch (error) {
    console.log(error);
  }
};
const continueCheckout = () => {
  isLoginOpen.value = false;
  createOrder(true);
};
const checkScrollPosition = () => {
  const checkoutBtn = document.getElementById("checkout_btn");
  if (!checkoutBtn) {
    return;
  }
  const checkoutBtnPosition = checkoutBtn.getBoundingClientRect(); // Get the position of the checkout button element

  if (
    checkoutBtnPosition.top >= 0 &&
    checkoutBtnPosition.bottom <=
      (window.innerHeight || document.documentElement.clientHeight)
  ) {
    hasReachedCheckout.value = true;
  } else if (hasReachedCheckout.value) {
    hasReachedCheckout.value = false;
  }
};
const sendDataLayerViewItem = () => {
  if (nuxtEnv === "prod") {
    let otherParams = {};
    if (getUser.id) {
      otherParams = {
        user_data: {
          first_name: getUser.username,
          email_address: getUser.email,
          user_id: getUser.id,
          customer_lifetime_spent: getUser.total_spent,
        },
      };
    }
    if (
      checkoutStore &&
      getUserCurrency &&
      price.value &&
      price.value !== 0 &&
      !viewItem.value &&
      window.dataLayer?.push
    ) {
      viewItem.value = true;
      window.dataLayer?.push({
        event: "view_item",
        ecommerce: {
          currency: getUserCurrencyCode,
          value: price.value.toFixed(2),
          items: [
            {
              item_id: "game_pack_" + checkoutStore.fullPack.id || "",
              item_name: checkoutStore.fullPack.title || "",
              affiliation: checkoutStore.fullPack.slug || "",
              coupon: checkoutStore.coupon || "",
              discount: 0,
              index: 0,
              item_brand: checkoutStore.fullGame.slug || "",
              price: price.value.toFixed(2),
              quantity: 1,
            },
          ],
        },

        ...otherParams,
      });
    }
  }
};

const showClassAndSpecializationMmo = computed(() => {
  if (currentGameSlug === "world-of-warcraft-boost" && categoryPackSlug) {
    if (categoryPackSlug === "wow-mythic-dungeon-boost") return true;
    if (categoryPackSlug === "wow-raid-boost") return true;
  }
  return false;
});

watch(
  () => checkoutStore,
  (newVal) => {
    try {
      if (newVal.game && newVal.fullPack?.id && newVal.startCalculating) {
        let result = calculateChoose(
          newVal.fullGame,
          newVal.fullPack,
          checkoutStore,
          getUser
        );
        price.value = result.price;

        basePrice.value = result.basePrice;
        time.value = result.time;
        nonDiscountedPrice.value = result.nonDiscountedPrice;
        cashback.value = result.cashback;
        nonDiscountedUsdPrice.value = result.nonDiscountedUsdPrice;
        nonDiscountedUsdPriceBase.value = result.nonDiscountedUsdPriceBase;
        setBasePrice(result.discountUsdPrice);
        // checkoutStore.setBasePrice()
        // if (use_cashback.value) {
        //   amount =
        //     props.orderData?.possible_cashback?.user_current_cashback
        //       ?.order_amount_with_user_cashback_discount;
        // }
        sendDataLayerViewItem();
      }
    } catch (error) {
      console.log(error);
    }
  },
  { deep: true }
);

watch(price, (newPrice) => {
  const amount = Math.round(newPrice * 100) || 1;
  if (!stripeElementsRef.value) return;

  stripeElementsRef.value.update({ amount });
});

watch(getGamePack, (newVal) => {
  if (newVal.coupon_enable === 0) {
    checkoutStore.removeCoupon();
  }
});
onNuxtReady(() => {
  hasMounted.value = true;
  if (getUser.username) {
    handleExpressCheckout();
  }
});

onMounted(() => {
  if (!hasMounted.value && getUser.username) {
    // handleExpressCheckout();
  }
});
watch(useCashback, (newValue) => {
  if (useCashback.value.includes("true")) {
    use_cashback.value = true;
  } else {
    use_cashback.value = false;
  }
});

watch(getUser, (newVal) => {});

onBeforeMount(() => {
  if (isMobile()) {
    window.addEventListener("scroll", checkScrollPosition);
    hasReachedCheckout.value = false;
  }
});
onBeforeUnmount(() => {
  if (isMobile()) {
    window.removeEventListener("scroll", checkScrollPosition);
  }
});
</script>
